import React from "react";
import explore from "../../assets/explore.png";
import Vector1 from "../../assets/products/Vector1.png";
import Nail from "../../assets/products/Nail.png";
import "../../styles/store.css";
import { Link } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
const { Search } = Input;

const MainStore = ({setSearchTerm}) => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <>
      <div className="bg-[#FCFBFA] relative -top-44 z-0 w-full h-lvh max-lg:h-[550px] store">
        <div className="relative top-44 z-10 px-20 max-lg:px-5">
          <div className="text-center">
            <h2 className="text-[#14294F] text-4xl max-lg:text-3xl font-bold mt-16 max-lg:mt-10 leading-relaxed">
              {t("YOUR GO TO STORE")}
            </h2>
            <p className="text-[#737E91] text-2xl mt-5 w-1/2 max-lg:w-full mx-auto">
              {t("Learn our range of services designed to meet all your home needs")}
            </p>

            <img
              src={Nail}
              alt="Nail"
              className="absolute left-1/2 top-28 w-[230px] max-lg:w-[150px] h-[140px] max-lg:h-[120px] z-0"
            />

            <Search
              placeholder={t("Search for a product")}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-[#FE9B71] w-[380px] max-lg:w-full h-[55px] mt-24 max-lg:mt-20 relative z-10 text-xl flex items-center justify-between mx-auto"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MainStore;
